module.exports = __webpack_public_path__ + "img/grand-vitara-boostergreenForm.26dec71a.svg";